export enum ChatMessageSender {
   Agent = 1,
   Peer = 2,
   Bot = 3,
}
